import { ActionType, ITeamMember, ITeamMemberRow } from './model'
import createReducer from '../createReducer'
import { Action, DEFAULT_ITEM_LIST, IItemList, Nullable } from '../model'

export interface ITeamReducer {
  team: IItemList<ITeamMemberRow>
  managerProfile: Nullable<ITeamMember>
  managerProfileLoading: boolean
}

const defaultState: ITeamReducer = {
  team: DEFAULT_ITEM_LIST,
  managerProfile: null,
  managerProfileLoading: true,
}

export const teamReducer = createReducer<ITeamReducer>(defaultState, {
  [ActionType.RESET_TEAM]() {
    return { ...defaultState }
  },

  [ActionType.SET_TEAM](state: ITeamReducer, action: Action<IItemList<ITeamMemberRow>>) {
    return { ...state, team: action.payload }
  },

  [ActionType.GET_MANAGER_PROFILE](state: ITeamReducer) {
    return { ...state, managerProfile: null, managerProfileLoading: true }
  },

  [ActionType.SET_MANAGER_PROFILE](state: ITeamReducer, action: Action<Nullable<ITeamMember>>) {
    return { ...state, managerProfile: action.payload, managerProfileLoading: false }
  },
})
